const DEFAULT_RECRUITER_APP_ORIGIN = 'https://recruiter.useskipscreen.com';

export function getRecruiterAppOrigin(): string {
  const configured = process.env.REACT_APP_RECRUITER_APP_URL?.trim();
  if (configured) {
    return configured.replace(/\/$/, '');
  }
  return DEFAULT_RECRUITER_APP_ORIGIN;
}

export function buildRecruiterProfileUrl(username: string): string {
  const slug = username.trim().replace(/^\/+/, '');
  if (!slug) return '';
  return `${getRecruiterAppOrigin()}/u/${encodeURIComponent(slug)}`;
}

/** Candidate-app public profile preview (owner view with ?preview=1). */
export function buildCandidateProfilePreviewUrl(username: string): string {
  const slug = username.trim().replace(/^\/+/, '');
  if (!slug) return '';
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/u/${encodeURIComponent(slug)}?preview=1`;
  }
  const configured = process.env.REACT_APP_CANDIDATE_APP_URL?.trim();
  const origin = configured ? configured.replace(/\/$/, '') : 'https://app.useskipscreen.com';
  return `${origin}/u/${encodeURIComponent(slug)}?preview=1`;
}
